import gql from 'graphql-tag'
import { COMPLIANCE_RESULT_FRAGMENT } from '@/components/compliances/queries/Compliances'

export const UpdateComplianceMutation = gql`
  mutation updateCompliance($input: UpdateComplianceInput!) {
    updateCompliance(input: $input) {
      ...ComplianceResultFragment
    }
  }
  ${COMPLIANCE_RESULT_FRAGMENT}
`
